import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class UploadService {
  private readonly endpoint = 'files/upload';

  constructor(private api: ApiService) {}

  uploadFile(file: File, description?: string, stockDetailId?: number): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    if (description) {
      formData.append('description', description);
    }
    if (stockDetailId != null) {
      formData.append('stock_detail_id', stockDetailId.toString());
    }

    return this.api.postFormData(this.endpoint, formData);
  }
}
